import React, { useState, useEffect, useRef } from 'react';
import { FormGroup, Label, Input, Container, Row, Col, Spinner } from 'reactstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown, faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import _, { uniqueId } from 'lodash';
import DatePicker from 'react-datepicker';
import Header from '../common/Header/Header';
import Banner from '../common/Header/Banner';
import Translate, { t } from '../common/Translate';
import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/it';
import 'moment/locale/pt';
import plusCircleIcon from '../../assets/img/plus-circle.svg';
import calendarIconBlue from '../../assets/img/calendar-blue.svg';
import MenuNavBottom from '../common/MenuNavBottom';
import MeetingTag from './MeetingTag';
import getConcessionsApi from '../../services/Form/getConcessionsApi';
import getSourcesApi from '../../services/Form/getSourcesApi';
import { Auth, recordManager } from '../../config/configuration/react';
import '../../assets/scss/react-datepicker.css';
import { datesFormat } from '../../config';
import useLocalStorage from '../../hooks/useLocalStorage/useLocalStorage';
import { calendarLang } from '../../language-context';
import AutobizStrapPopup from '../common/Modal/AutobizStrapPopup';

const Calendar = (props) => {
  const userId = Auth.userId();
  const { location } = props;
  const [filterDay, setFilterDay] = useLocalStorage(`${userId}.filterDay`, moment().format('YYYY-MM-DD'));
  const [currentDay, setCurrentDay] = useState(filterDay);
  const [sourceId, setSourceId] = useLocalStorage(`${userId}.sourceId`, '');
  const [filterPointOfSale, setFilterPointOfSale] = useLocalStorage(`${userId}.filterPointOfSale`, null);
  const [filtersPanelOpen, setFiltersPanelOpen] = useState(false);
  const [pointOfSales, setPointOfSales] = useState(null);
  const [sources, setSources] = useLocalStorage(`${userId}.sources`, []);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [schedules, setSchedules] = useState({
    '09:00': [],
    '10:00': [],
    '11:00': [],
    '12:00': [],
    '13:00': [],
    '14:00': [],
    '15:00': [],
    '16:00': [],
    '17:00': [],
    '18:00': [],
    '19:00': [],
  });
  let mode = '';
  const lang = Auth.preferredLanguage();
  let isCalled = false;
  // Generate schedule default list from 9:00 to 19:00
  const times = [];
  let i = 0;
  let j = 0;
  const isMounted = useRef(false);
  for (i = 9; i < 20; i += 1) {
    for (j = 0; j < 1; j += 1) {
      times.push(`${i === 9 ? '09' : i}:${j === 0 ? '00' : 30 * j}`);
    }
  }

  const appLang = lang.toUpperCase();

  const getConcessions = async (id) => {
    setLoading(true);
    if (isCalled) return;
    isCalled = true;
    const res = await getConcessionsApi({ value: id });
    if (isMounted.current) return;
    if (res.length > 0) {
      setPointOfSales(res);
    }
    isCalled = false;
  };

  const getSources = async () => {
    setLoading(true);
    const res = await getSourcesApi();
    if (res.length > 0) {
      if (!sourceId) {
        if (Auth.sourceId() > 0) {
          setSourceId(Auth.sourceId());
        } else {
          setSourceId(res[0].id);
        }
      }
      setSources(res);
    }
  };

  const checkSchedules = () => {
    Object.keys(schedules).forEach((time) => {
      schedules[time] = [];
    });
  };

  const constructData = (res) => {
    let _res = res;
    if (isMounted.current) return;
    checkSchedules();
    if (_res.length === undefined) _res = [_res];
    if (!_res.length) {
      setSchedules({
        '09:00': [],
        '10:00': [],
        '11:00': [],
        '12:00': [],
        '13:00': [],
        '14:00': [],
        '15:00': [],
        '16:00': [],
        '17:00': [],
        '18:00': [],
        '19:00': [],
      });
    } else {
      const data = { ...schedules };
      _res.forEach((appointment) => {
        const date = _.get(appointment, 'appointmentTime', '');
        Object.entries(data).forEach(([key, value]) => {
          if (key === date) value.push(appointment);
        });
      });
      setSchedules(data);
    }
  };

  const getAppointementFiles = async () => {
    setError(false);
    const query = {};
    setLoading(true);
    if (sourceId && sourceId > 0) {
      if (pointOfSales && pointOfSales.length > 0) {
        const concessionIds = pointOfSales.map(function (pointOfSale) {
          return pointOfSale.id;
        });
        if (filterPointOfSale && concessionIds.includes(parseInt(filterPointOfSale, 10))) {
          query.concessionId = filterPointOfSale;
        } else {
          setFilterPointOfSale(null);
        }
      }
      if (sourceId) query.sourceId = parseInt(sourceId, 10);
      if (filterPointOfSale && filterPointOfSale > 0) query.concessionId = parseInt(filterPointOfSale, 10);
      query.appointmentDate = currentDay;
      try {
        const { records } = await recordManager.search(query);
        constructData(records);
      } catch (e) {
        setError(t('error_get_meetings'));
      } finally {
        if (!isMounted.current) setLoading(false);
      }
      setLoading(false);
    }
  };

  const getData = (key, value) => {
    mode = 'filter';
    if (key === 'meetingDate') {
      if (value) {
        const date = moment(value).format('YYYY-MM-DD');
        // setFilterDay(date);
        setCurrentDay(date);
      } else {
        // setFilterDay(null);
        setCurrentDay(null);
      }
    } else if (key === 'meetingPointOfSale') {
      setFilterPointOfSale(value.target.value);
    } else if (key === 'meetingSource') {
      setSourceId(value.target.value);
      setFilterPointOfSale(null);
    }
  };

  useEffect(() => {
    if (location.state === '') _.set(props, 'location.state', 'calendar');
    return () => {
      isMounted.current = true;
    };
  }, [location.state]);

  const getAppointment = async () => {
    setLoading(true);
    if (!sources || sources.length === 0) await getSources();
    if (sourceId) await getConcessions(sourceId);
    await getAppointementFiles();
    setLoading(false);
  };

  useEffect(() => {
    if (mode !== 'filter') {
      setFilterDay(currentDay);
      getAppointment();
    }
  }, [currentDay, sourceId]);

  useEffect(() => {
    if (filterPointOfSale) getAppointementFiles();
  }, [filterPointOfSale]);

  const openFiltersPanel = () => {
    setFiltersPanelOpen(!filtersPanelOpen);
  };

  const setNextMonday = () => {
    setCurrentDay(moment(currentDay).isoWeekday(1).day(8).format('YYYY-MM-DD'));
  };

  const setToday = () => {
    setCurrentDay(moment(new Date()).format('YYYY-MM-DD'));
  };

  const setPreviousMonday = () => {
    setCurrentDay(moment(currentDay).day(-6).format('YYYY-MM-DD'));
  };

  const setDayOfWeek = (value) => {
    const day = value;
    const current = moment(currentDay).isoWeekday(1).day(day).format('YYYY-MM-DD');
    setCurrentDay(current);
    mode = '';
  };

  const addMettingButton = (time) => (
    <Link
      to={{
        pathname: '/calendar/create',
        state: {
          origin: 'calendar',
          queries: {
            date: currentDay,
            time,
            concessionId: parseInt(filterPointOfSale, 10),
          },
        },
      }}
      className="add-metting-button"
    >
      <img src={plusCircleIcon} alt="add" />
      <span className="text">{t('add_meeting')}</span>
    </Link>
  );
  return (
    <>
      <AutobizStrapPopup />
      <Header noBack title="Carcheck" />
      <Banner />
      <MenuNavBottom active="calendar" />

      <h1 className="page-title">
        <span className="cursor-pointer" onClick={() => setToday()} onKeyDown={() => {}} role="presentation">
          <img src={calendarIconBlue} alt="" height="25" /> {t('my_meetings')}
        </span>
        <button
          type="button"
          onClick={() => openFiltersPanel()}
          className={`btn d-lg-none refresh-button ${filtersPanelOpen ? 'btn-3' : 'btn-2'}`}
        >
          {t('filters')} <FontAwesomeIcon icon={filtersPanelOpen ? faChevronUp : faChevronDown} />
        </button>
      </h1>

      <div className="filters-results-container">
        <div className={`filters-container${filtersPanelOpen ? ' open' : ''}`}>
          <Container fluid>
            <Row>
              <Col>
                <div className="title">{t('filters')}</div>
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6" lg="12">
                <FormGroup>
                  <Label className="text-secondary mb-1 text-left text-uppercase" for="meetingDate">
                    {t('meetingDate')}
                  </Label>
                  <DatePicker
                    className="form-control rounded"
                    name="meetingDate"
                    id="meetingDate"
                    onChange={(e) => {
                      getData('meetingDate', e);
                    }}
                    selected={filterDay ? new Date(filterDay) : ''}
                    locale={calendarLang[appLang]}
                    dateFormat={appLang === 'DE' ? datesFormat[appLang] : datesFormat.default}
                    placeholderText={t('date_placeholder')}
                    autoComplete="off"
                  />
                </FormGroup>
              </Col>
              <Col xs={12} sm={6} lg={12}>
                <FormGroup>
                  <Label className="text-secondary mb-1 text-left text-uppercase">{t('sources')}</Label>
                  <Input
                    className="form-control rounded icon-location"
                    type="select"
                    name="meetingSource"
                    id="meetingSource"
                    onChange={(e) => {
                      getData('meetingSource', e);
                    }}
                    value={(sourceId && sourceId) || null}
                  >
                    {sources &&
                      sources.map((source) => (
                        <option key={source?.id} value={source?.id}>
                          {source?.source}
                        </option>
                      ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" lg="12">
                <FormGroup>
                  <Label className="text-secondary mb-1 text-left text-uppercase" for="meetingPointOfSale">
                    {t('pointOfSale')}
                  </Label>
                  <Input
                    className="form-control rounded icon-location"
                    type="select"
                    name="meetingPointOfSale"
                    id="meetingPointOfSale"
                    onChange={(e) => {
                      getData('meetingPointOfSale', e);
                    }}
                    value={filterPointOfSale}
                  >
                    <option key="select_concessions" value={0}>
                      {t('select_concessions')}
                    </option>
                    {pointOfSales &&
                      pointOfSales.map((pos) => (
                        <option key={pos.id} value={pos.id}>
                          {pos.name}
                        </option>
                      ))}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          </Container>
        </div>

        <div className="results-container">
          <div className="calendar-week-container">
            <div className="calendar-week">
              <div className="week-nav" onClick={() => setPreviousMonday()} onKeyDown={() => {}} role="presentation">
                <FontAwesomeIcon icon={faChevronLeft} />
              </div>
              {[1, 2, 3, 4, 5, 6, 7].map((day) => (
                <div
                  key={uniqueId(day)}
                  onClick={() => setDayOfWeek(day)}
                  className={
                    moment(currentDay).locale(lang).day() === day ||
                    (moment(currentDay).locale(lang).day() === 0 && day === 7)
                      ? 'calendar-day current'
                      : 'calendar-day'
                  }
                  onKeyDown={() => {}}
                  role="presentation"
                >
                  {moment().locale(lang).day(day).format('ddd')}
                </div>
              ))}
              <div className="week-nav" onClick={() => setNextMonday()} onKeyDown={() => {}} role="presentation">
                <FontAwesomeIcon icon={faChevronRight} />
              </div>
            </div>
          </div>

          <div className="h5 text-center text-uppercase text-primary mb-5">
            {moment(currentDay).locale(lang).format('dddd D MMMM YYYY')}
            {loading && (
              <div className="text-center">
                <Spinner color="primary" />
              </div>
            )}
            {error && (
              <p className="text-center text-danger">
                <Translate code={error} />
              </p>
            )}
          </div>

          {times.map((time) => (
            <div key={uniqueId(time)} className="schedule">
              <div className="schedule-caption">
                <span className="schedule-time">{time}</span>

                {(`${currentDay} ${time}` > `${moment().subtract(1, 'hours').format('YYYY-MM-DD HH')}:00` &&
                  !Auth.roleViewerAccess() &&
                  addMettingButton(time)) ||
                  ''}
              </div>
              {schedules[time].length > 1 && (
                <span style={{ color: '#FF4E00' }}>
                  <strong>{schedules[time].length}</strong> {t('number_of_appointement')}
                </span>
              )}
              {schedules[time] && (
                <div className="schedule-touch-container">
                  <div className="schedule-row">
                    {schedules[time] &&
                      schedules[time].map((schedule) => (
                        <Link
                          to={{
                            pathname: `/files/${schedule.recordId}`,
                            state: { origin: 'calendar' },
                          }}
                          className="schedule-col"
                          key={uniqueId(schedule)}
                        >
                          <div className="schedule-info">
                            <div className="title">
                              {schedule.brandName} {schedule.modelName} -{' '}
                              {schedule.registrationDate && moment(schedule.registrationDate.date).format('YYYY')}
                            </div>
                            {schedule.statusCarcheck && <MeetingTag code={schedule.statusCarcheck} />}
                            <Row>
                              <Col>{t('registration')}</Col>
                              <Col className="font-weight-bold text-right">{schedule.registration}</Col>
                            </Row>
                            <Row>
                              <Col>{t('folder')}</Col>
                              <Col className="font-weight-bold text-right">{schedule.refHexaId}</Col>
                            </Row>
                          </div>
                        </Link>
                      ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Calendar;

Calendar.propTypes = {
  location: PropTypes.shape().isRequired,
};
